export default __webpack_public_path__ + "static/media/Icon_Alert.b8c6b05d.svg";